import { render, staticRenderFns } from "./ProRetouchersMainPhotoBlock.vue?vue&type=template&id=71bf1367&"
import script from "./ProRetouchersMainPhotoBlock.vue?vue&type=script&lang=js&"
export * from "./ProRetouchersMainPhotoBlock.vue?vue&type=script&lang=js&"
import style0 from "./ProRetouchersMainPhotoBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports